import React from "react";
import { useFormContext } from "react-hook-form";
import { Forms } from "@/types/form";
import { Styled } from "./styles";

interface Props {
    variant: "incomings" | "outgoings";
    index: number;
}

const CommentField: React.FC<Props> = ({ variant, index }) => {
    const { register } = useFormContext<Forms["Category"]>();

    return (
        <Styled.TextField
            variant="outlined"
            fullWidth={true}
            {...register(`${variant}.${index}.comment`)}
        />
    );
};

export default CommentField;
